import React from "react";
import styles from "./AllInfoContainer.module.scss";
import Title from "../../../../ui/Title/Title";
import { LoadingComponent } from "../../../LoadingComponent/LoadingComponent";
import { ErrorComponent } from "../../../ErrorComponent/ErrorComponent";
import { AmoCRMIcon } from "../../../../assets/icons/AmoCRMIcon";

export const AllInfoContainer = ({ activeAmo, errorAmo }) => {
  const DataItem = ({ title, data, link }) => {
    return (
      <div className={styles.dataItemContainer}>
        <div className={styles.dataItemContainerFlex}>
          <label className={styles.title}>{title}</label>
        </div>
        <label className={styles.data}>
          {link ? (
            <a
              href={data}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              {data}
            </a>
          ) : (
            data
          )}
        </label>
      </div>
    );
  };

  console.log("activeAmo", activeAmo);

  function maskLink(link) {
    if (link.length <= 5) return link; // если строка слишком короткая, не маскируем

    const start = link.slice(0, 3);
    const end = link.slice(-2);
    return `${start}****${end}`;
  }

  return (
    <div className={styles.container}>
      {errorAmo && (
        <ErrorComponent
          title={"Произошла ошибка при получении данных AmoCRM"}
          text={
            "При получении данных о вашем аккаунте произошла ошибка. Вы можете вернуться на страницу интеграций и попробовать открыть страницу еще раз."
          }
          buttonTitle={"Вернуться на страницу интеграций"}
          path={"/integration"}
        />
      )}
      {activeAmo && !errorAmo ? (
        <>
          <div className={styles.header}>
            <div className={styles.headerInfoContainer}>
              <div className={styles.headerInfoContainerTitle}>
                <Title
                  title={activeAmo?.dataUser?.name}
                  className={styles.title}
                />
                <AmoCRMIcon width={90} height={20} fill={"#3e8fcb"} />
              </div>
            </div>
          </div>

          {activeAmo && !errorAmo && (
            <>
              <div className={styles.rowData}>
                <DataItem
                  title={"apiURL"}
                  data={activeAmo?.dataUser?.apiURL}
                  link={true}
                />
                <DataItem
                  title={"Описание"}
                  data={activeAmo?.dataUser?.description}
                />
              </div>

              <div className={styles.rowData}>
                <DataItem
                  title={"Секретный ключ"}
                  data={maskLink(activeAmo?.dataUser?.secretKey)}
                />
                <DataItem
                  title={"Токен"}
                  data={maskLink(activeAmo?.dataUser?.token)}
                />
              </div>
            </>
          )}
        </>
      ) : (
        !errorAmo && <LoadingComponent />
      )}
    </div>
  );
};
